export const registrationService = {
    register
};

function register(email, firstName, lastName, password, confirmPassword, phoneNumber, account) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, firstName, lastName, password, confirmPassword, phoneNumber, account })
    };
    return fetch(process.env.VUE_APP_ROOT_API + '/register', requestOptions)
        .then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            return Promise.reject(data);
        }
        return data;
    });
}
